<template>
    <VeeField name="telephone" v-model="useReservationFormData().value.telephone" v-slot="{field, meta, errors}" rules="required|number">
        <div :class="meta.touched ? (meta.valid) ? 'valid' : 'invalid' : ''" >
            <input v-bind="field" class="inp sm" type="text" placeholder="Telefonnummer*" />
        </div>
        <span>{{ errors[0] }}</span>
    </VeeField>
</template>